import FeatureFlags from '@/mixins/FeatureFlags';
import Analytics from '@/mixins/Analytics';

const computed = {
  eulaAcceptanceRequired() {
    return this.featureFlags[this.featureFlagSlugs.requireEulaAcceptanceForLanes];
  },
};
const methods = {
  openEulaModal({
    configuredLanes = [],
    originPoint = 'srp',
    intercepted = true,
    additionalProperties = {},
  }) {
    this.$store.dispatch('auctionCommonModals/updateModalContext', {
      modalBeingShown: 'eulaTermsOfAcceptance',
      originPoint,
      additionalProperties: {
        ...additionalProperties,
        configuredLanes,
      },
    });

    if (intercepted) {
      this.track(this.eventNames.marketplaceV2.eulaIntercepted, {
        lane_id: configuredLanes[0]?.id,
        lane_name: configuredLanes[0]?.displayName,
      });
    }
  },
  validateEula(isInConfiguredLane, lane) {
    // check lane exists with keys and is valid without eula to want to validate eula
    if (Object.keys(lane || {}).length) {
      return isInConfiguredLane && !lane?.eulaAccepted && this.eulaAcceptanceRequired;
    }

    return false;
  },
  updateVdpAuctionModelEulaAccepted() {
    this.$store.dispatch('marketplaceAuctions/updateViewingAuctionModel', {
      auction: {
        ...this.$store.state.marketplaceAuctions.viewingAuctionModel.auction,
        eula_accepted: true,
      },
    });
  },
};

export default {
  computed,
  methods,
  mixins: [
    FeatureFlags,
    Analytics,
  ],
};
